import { get } from 'lodash-es';
import { DELIVERY_CODES } from 'site-modules/shared/components/delivery/constants';

export function showZipLongDistanceConfirmScreen({ showZipLongDistanceConfirm, inventory }) {
  return (
    showZipLongDistanceConfirm &&
    get(inventory, 'dealerInfo.distance') > 200 &&
    !DELIVERY_CODES.includes(get(inventory, 'deliveryOptions.deliveryCode', ''))
  );
}
